export default __webpack_public_path__ + "static/media/Rex.6408c9db.png";